import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

type Step = "setup" | "in-progress" | "review";

interface StepIndicatorProps {
  currentStep: Step;
}

const steps: { id: Step; label: string; number: number }[] = [
  { id: "setup", label: "Setup", number: 1 },
  { id: "in-progress", label: "In Progress", number: 2 },
  { id: "review", label: "Review", number: 3 },
];

export function StockTakeStepIndicator({ currentStep }: StepIndicatorProps) {
  const currentStepIndex = steps.findIndex((step) => step.id === currentStep);

  const isStepComplete = (stepIndex: number) => stepIndex < currentStepIndex;
  const isStepCurrent = (stepIndex: number) => stepIndex === currentStepIndex;

  return (
    <div className="w-full">
      <div className="flex items-center justify-between max-w-3xl mx-auto">
        {steps.map((step, index) => (
          <div key={step.id} className="flex items-center flex-1">
            {/* Step Circle */}
            <div className="flex flex-col items-center">
              <div
                className={cn(
                  "w-12 h-12 rounded-full flex items-center justify-center font-semibold transition-all",
                  isStepComplete(index) &&
                    "bg-primary text-primary-foreground shadow-md",
                  isStepCurrent(index) &&
                    "bg-primary text-primary-foreground shadow-lg ring-4 ring-primary/20",
                  !isStepComplete(index) &&
                    !isStepCurrent(index) &&
                    "bg-muted text-muted-foreground"
                )}
              >
                {isStepComplete(index) ? (
                  <Check className="h-6 w-6" />
                ) : (
                  <span className="text-lg">{step.number}</span>
                )}
              </div>
              <div className="mt-2 text-center">
                <div
                  className={cn(
                    "text-sm font-medium transition-colors",
                    (isStepComplete(index) || isStepCurrent(index)) &&
                      "text-foreground",
                    !isStepComplete(index) &&
                      !isStepCurrent(index) &&
                      "text-muted-foreground"
                  )}
                >
                  {step.label}
                </div>
              </div>
            </div>

            {/* Connector Line */}
            {index < steps.length - 1 && (
              <div
                className={cn(
                  "flex-1 h-1 mx-4 rounded-full transition-all",
                  isStepComplete(index) ? "bg-primary" : "bg-muted"
                )}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
